<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="4" xl="4">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <span><i class="fa fa-user"></i>&nbsp; Tipo de rol </span>
            <button @click="mtdBack" type="button" class="btn btn-sm text-white" style="background: #E46666">
              <i class="fas fa-hand-point-left"></i> Retroceder
            </button>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="12">
                <cSelectForm label="Seleccione Tipo Rol" :options="data_roles" placeholder="Escoja un Tipo Rol"
                  :value.sync="form_add_role.role_id" @change="form_selected" />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12">
                <button type="button" :disabled="vue.estado == 1 ? true : false" style="background: #926cdc"
                  :class="btnClasses" @click="loadTable">
                  <i class="fas fa-search"></i>&nbsp; Buscar
                </button>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol v-if="vue.exp" xs="12" sm="12" md="8" lg="8" xl="8">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de usuarios" icon="fas fa-users" btn_name="Usuario" @mtdBack="mtdBack"
          @show_modal="mtd_open_modal" @action_edit="mtd_show" @action_delete="mtd_delete" :size="'md'"
          :button_new="true" :actions="true" :withActions="'10%'" :buttonEdit="true" :buttonDelete="true"
          :myButtons="myButtons" @mtd_pass="mtd_pass" />
      </CCol>
    </CRow>
    <!-- modal -->
    <CModalForm :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="modal.title" :button="cp_button"
      :show.sync="modal.modal_form" @mtd_action="mtd_action" :color="'info'" :centered="false">
      <CRow>
        <CCol sm="12">
          <cSelectForm label="Empresa" placeholder="Seleccione empresa" :options="data_companies"
            :value.sync="users.company_id" @change="indexCampus"
            :disabled="this.modal.action == 'update' || this.$store.getters.get_rol.id != 1" />
        </CCol>
        <CCol sm="12" v-if="this.form_add_role.role_id != 4 && this.form_add_role.role_id != 1">
          <cSelectForm label="Sede" placeholder="Seleccione sedes" :options="data_campus" :value.sync="users.campu_id"
            :disabled="this.modal.action == 'update'" />
        </CCol>
        <CCol sm="12">
          <CInput label="DNI" placeholder="Digite DNI" v-model="users.dni" maxlength="8"
            v-on:keypress="isNumber($event)" />
          <CInput type="hidden" v-model="users.document_type" />
          <CInput type="hidden" v-model="users.rol_id" />
        </CCol>
        <CCol sm="12">
          <CInput label="Nombre" placeholder="Digite Nombre" v-model="users.name" />
        </CCol>
        <CCol sm="12">
          <CInput label="Apellido" placeholder="Digite Apellido" v-model="users.last_name" />
        </CCol>

        <CCol sm="12">
          <CInput label="Email" placeholder="Digite Email" v-model="users.email" @input="validateEmail(users.email)" />
          <span v-if="errors.email_user" class="text-danger">{{ errors.email_user }}</span>
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal password -->
    <CModalForm :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="modal.title" :button="cp_button_pass"
      :show.sync="modal.modal_form_pass" @mtd_action="mtd_action_pass" :color="'info'" :centered="true">
      <CRow>
        <CCol sm="12">
          <CInput type="password" label="Nueva Contraseña" placeholder="Digite Contraseña" v-model="pass.password" />
        </CCol>
      </CRow>
    </CModalForm>


    <!-- modal delete -->
    <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar usuario'"
      :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
  </div>
</template>
<script>
const fields = [
  { key: "index", label: 'Id', _style: "width:3%" },
  { key: "Nombre", _style: "width:15%;" },
  { key: "Apellidos", _style: "width:15%;" },
  { key: "Email", _style: "width:15%;" },
  // {
  //   key: 'show_details',
  //   label: 'Detalle',
  //   _style: 'min-width:1%'
  // },
];
import CTableWrapper from "../../components/shared/datatable/Table.vue";
import CModalForm from "../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../components/shared/modals/cModalDelete.vue";
import cSelectForm from "../../components/shared/inputs/cSelect.vue";
import { mapActions } from "vuex";
export default {
  components: { CTableWrapper, CModalForm, cModalDelete, cSelectForm },
  data() {
    return {
      prefix: "users",
      data_companies: [],
      data_campus: [],
      vue: {
        exp: false,
        texto: "",
        estado: 1,
      },
      fields,
      data: [],
      myButtons: [
        {
          class: "btn-sm",
          color: "success",
          tooltip: "Cambiar contraseña",
          action: "mtd_pass",
          icon: "fas fa-key",
          // play: {
          //   type: "type_id_add_alternativas", //resource
          //   1: true,
          //   2: false,
          // },
        },
      ],
      data_roles: [],
      form_add_role: {
        role_id: "",
        permission_id: "",
        state: 1,
      },
      modal: {
        action: "",
        title: "",
        modal_form: false,
        modal_form_pass: false,
      },
      pass: {
        id: "",
        password: "",
      },
      users: {
        id: "",
        name: "",
        last_name: "",
        dni: "",
        document_type: "",
        rol_id: "",
        email: "",
        status: "",
        company: this.$store.getters.get_company,
        campu: this.$store.getters.get_campu,
        company_id: this.$store.getters.get_rol.id != 1 ? this.$store.getters.get_company.id : "",
        campu_id: "",
      },
      errors: {
        email_user: "",
      },
      modal_delete: {
        boo: false,
        item: [],
      },
    };
  },
  created() {
    this.mtdGetDataRol();
    this.indexCompany();
  },
  computed: {
    cp_button: function () {
      if (this.users.dni.length == 8 && this.users.name != "" && this.users.last_name != "" && this.users.email != "" && this.errors.email_user == "") return false;
      return true;
    },
    cp_button_busqueda: function () {
      if (this.form_add_role.role_id != "") return false;
      return true;
    },
    cp_button_pass: function () {
      if (this.form_add_role.role_id != "") return false;
      return true;
    },
    btnClasses() {
      return [`btn text-white w-100`];
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdGetDataRol: function () {
      this.get({
        url: this.$store.getters.get__url + "/rol",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let allRoles = response.data.data_roles;
          let userRoles = this.$store.getters.get_all_user.roles;
          if (userRoles[0].role_id == 1) {
            this.data_roles = allRoles;
          } else {
            this.data_roles = response.data.data.map(item => ({
              ...item,
              value: item.Id,
              label: item.Nombre
            }));
          }
        })
        .catch((errors) => { });
    },
    loadTable: function () {
      let id = this.form_add_role.role_id;
      if (id != 0) {
        this.vue.exp = true;
      } else {
        this.vue.exp = false;
      }
      this.mtd_getdata_captionrol(id);
      this.mtd_getdata_usuariosxrol(id);
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mtdBack: function () {
      this.$emit('mtdBack');
    },

    form_selected: function () {
      this.vue.estado = 0;
    },

    mtd_getdata_captionrol: function (id) {
      this.get({
        url: this.$store.getters.get__url + "/rol/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.vue.texto = "Lista de Usuarios: " + response.data.name;
        })
        .catch((errors) => { });
    },
    mtd_getdata_usuariosxrol: function (id) {
      let url;
      if (this.$store.getters.get_company == null) {
        url =
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/rol/" +
          id +
          "/0/" + this.$store.getters.get_all_user.id;
      } else {
        url =
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/rol/" +
          id +
          "/" +
          this.$store.getters.get_company.id +
          "/" +
          this.$store.getters.get_all_user.id;
      }
      this.get({
        url: url,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
        })
        .catch((errors) => { });
    },
    indexCompany: function () {
      this.get({
        url: this.$store.getters.get__url + "/users/bycompany",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data_companies = [];
          this.data_campus = [];
          response.data.forEach((element) => {
            this.data_companies.push({
              label: element.name,
              value: element.id,
            });
          });
          if (this.$store.getters.get_rol.id != 1) {
            this.indexCampus();
          }
        })
        .catch((errors) => { });
    },

    indexCampus: function () {
      this.get({
        url: this.$store.getters.get__url + "/users/bycampus/" + this.users.company_id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data_campus = [];

          response.data.forEach((element) => {
            this.data_campus.push({
              label: element.name,
              value: element.id,
            });
          });
        })
        .catch((errors) => { });
    },

    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      if (action == "store") {
        this.modal.title = "Nuevo Usuario";
      } else {
        this.modal.title = "Editar Usuario";
      }
      let rol_id = this.form_add_role.role_id;
      if (action == "store") {
        this.users = {
          id: "",
          name: "",
          last_name: "",
          dni: "",
          document_type: "DNI",
          rol_id: rol_id,
          email: "",
          status: "",
          company: this.$store.getters.get_company,
          campu: this.$store.getters.get_campu,
          company_id: this.$store.getters.get_rol.id != 1 ? this.$store.getters.get_company.id : "",
          campu_id: "",
        }
        this.errors = {
          email_user: "",
        }
        this.indexCompany();
      } else {
        this.users = this.users;
        this.errors = {
          email_user: "",
        }
        this.indexCompany();
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.users,
      })
        .then((response) => {
          let color = "success";
          let message = "";
          if (this.modal.action == "store") {
            this.data.push(response.data[0]);
            message = "REGISTRADO CORRECTAMENTE";
            let rol_id = this.form_add_role.role_id;
            // this.mtd_getdata_captionrol(rol_id);
            // this.mtd_getdata_usuariosxrol(rol_id);
          } else {
            this.data.forEach((element) => {
              if (element.Id == response.data[0].Id) {
                element.Nombre = response.data[0].Nombre;
                element.Apellidos = response.data[0].Apellidos;
                element.Documento = response.data[0].Documento;
                element.rol_id = response.data[0].rol_id;
                element.Email = response.data[0].Email;
              }
              message = "EDITADO CORRECTAMENTE";
              let rol_id = this.form_add_role.role_id;
              // this.mtd_getdata_captionrol(rol_id);
              // this.mtd_getdata_usuariosxrol(rol_id);
            });
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            name: "",
            last_name: "",
            document_type: "",
            dni: "",
            rol_id: "",
            email: "",
          };
          this.data_roles = []
          this.data_companies = [];
          this.data_campus = [];
          Swal.fire({
            title: message,
            icon: color,
          });
          this.mtdGetDataRol();
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_pass: function (id) {
      this.modal.modal_form_pass = true;
      this.modal.title = "Cambiar Contraseña";
      this.pass.id = id.Id;
      this.pass.password = "";
    },
    mtd_action_pass: function () {
      let color = "success";
      let message = "";
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/new_password",
        token: this.$store.getters.get__token,
        params: this.pass,
      })
        .then((response) => {
          message = "REGISTRADO CORRECTAMENTE.";

          this.modal = {
            action: "",
            title: "",
            modal_form_pass: false,
            id: "",
            password: "",
          };
          this.pass = {
            id: "",
            password: "",
          }
          Swal.fire({
            title: message,
            icon: color,
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.errors.email_user = "";
          this.users = response.data;
          this.users.company = this.$store.getters.get_company;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          let temp = [];
          this.data.forEach((element) => {
            if (element.Id != response.data) {
              temp.push(element);
            }
          });
          this.data = temp;
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email == this.users.email) {
        if (!emailPattern.test(email)) {
          this.errors.email_user = "El correo electrónico no tiene un formato válido";
        } else {
          this.errors.email_user = "";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>